<template>
  <div style="width: 1200px; margin: 0 auto; background-color: #F2F6FC;">
<!--    <Title :title="route"></Title>-->
    <el-card class="box-card" style="min-height: 650px;margin-top: 15px;" shadow="never">
      <el-form :model="detail" label-position="left" label-width="150px" ref="detail" :rules="rules">
        <el-divider content-position="left">申请人信息</el-divider>
        <el-form-item label="申请人">
          <el-input v-model="user.realName" readonly></el-input>
        </el-form-item>
        <el-form-item label="所属部门">
          <el-input v-model="user.deptName" readonly></el-input>
        </el-form-item>
        
        <el-divider content-position="left">采购申请单</el-divider>
        <el-form-item label="采购类型" prop="purchaseType">
          <el-radio-group v-model="detail.purchaseType" style="cursor: not-allowed;pointer-events:none">
            <el-radio label="1">办公耗材</el-radio>
            <el-radio label="2">固定资产</el-radio>
            <el-radio label="3">项目采购</el-radio>
            <el-radio label="4">其他</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="申请到货时间" prop="arrivalTime">
          <el-date-picker
            readonly
            v-model="detail.arrivalTime"
            placeholder="请选择到货时间"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <div v-if="detail.purchaseType === '3'">
          <el-form-item label="项目名称" prop="projectId">
            <el-input v-model="detail.projectName" readonly></el-input>
          </el-form-item>
        </div>
        <el-form-item label="紧急程度" prop="urgencyLevel">
          <el-radio-group v-model="detail.urgencyLevel" style="cursor: not-allowed;pointer-events:none">
            <el-radio label="1">正常</el-radio>
            <el-radio label="2">加急</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="申购理由" prop="purchaseReason">
          <el-input type="textarea" rows="5" maxlength="500" show-word-limit v-model="detail.purchaseReason" readonly></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" rows="2" maxlength="100" show-word-limit v-model="detail.remarks" readonly></el-input>
        </el-form-item>
        
        <el-divider content-position="left">物品清单</el-divider>
        <el-form-item label="物品名称" prop="itemName">
          <el-input v-model="detail.itemName" readonly></el-input>
        </el-form-item>
        <el-form-item label="物品数量" prop="itemNumber">
          <el-input-number v-model="detail.itemNumber" :min="1" :max="100" disabled></el-input-number>
        </el-form-item>
        <div v-if="show">
          <el-form-item label="厂家" prop="factory">
            <el-input v-model="detail.factory" :readonly="read"></el-input>
          </el-form-item>
          <el-form-item label="型号" prop="model">
            <el-input v-model="detail.model" :readonly="read"></el-input>
          </el-form-item>
          <el-form-item label="单价" prop="price">
            <el-input v-model="detail.price" :readonly="read"></el-input>
          </el-form-item>
          <el-form-item label="付款方式" prop="payType">
            <el-radio-group v-model="detail.payType" :disabled="read">
              <el-radio label="1">公对公转账</el-radio>
              <el-radio label="2">备用金支付</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        
        <AuditList :audits="audits" :auditHistory="auditHistory"></AuditList>
        <div v-if="allowAudit===true">
          <el-divider content-position="left">我要审批</el-divider>
          <el-form-item label="审批意见" prop="remarks">
            <el-input
              type="textarea" rows="5"
              maxlength="500" show-word-limit
              v-model="ruleForm.auditOpinion">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-popconfirm
              title="该操作无法撤回，是否已经仔细查阅？"
              @confirm="audit(2)">
              <el-button
                style="margin-left: 10px" slot="reference" type="primary">
                审批通过
              </el-button>
            </el-popconfirm>
            <el-popconfirm
              title="该操作无法撤回，是否已经仔细查阅？"
              @confirm="audit(3)">
              <el-button
                style="margin-left: 10px" slot="reference" type="danger">
                审批拒绝
              </el-button>
            </el-popconfirm>
          </el-form-item>
        </div>
      </el-form>
    </el-card>
    <Setp :nodes="nodes" :audits="audits"></Setp>
  </div>
</template>

<script>
import Title from "../../Title";
import Setp from "../common/Setp";
import AuditList from "../common/AuditList";
import { AesDecrypt, isNum } from "@/util";
import {requestApplyDetail, requestAudit, requestAuditShow, requestPurchaseBack, requestProjectAllGet} from "@/api";
export default {
  components: {Title, AuditList, Setp},
  name: "PurchaseApply",
  props: {
    // 接收父组件传入的参数
    query: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const validatePrice = (rule, value, callback) => {
      if (!value) {
        callback(new Error("金额不能为空"));
      } else if (!isNum(value)) {
        callback(new Error("请输入正确格式的金额"));
      } else if (value.split(".").length > 2) {
        callback(new Error("请输入正确格式的金额")); //防止输入多个小数点
      } else if (value.indexOf(".") > -1 && value.substring(value.indexOf(".") + 1).length > 2) {
        callback(new Error("最大保留两位小数"));
      } else if (value.length > 12) {
        callback(new Error("长度最大12个字符"))
      } else {
        this.ruleForm.reimburseMoney = value
        callback();
      }
    };
    return {
      route: {
        name: '采购申请',
        path: ""
      },
      read: false,
      user: {},
      detail: {},
      audits: [],
      nodes:[],
      allowAudit: false,
      auditHistory: [],
      ruleForm: {},
      back: {},
      show: true,
      rules: {
        factory: [
          {required: true, message: '请回填采购厂家', trigger: 'submit'}
        ],
        model: [
          {required: true, message: '请回填物品型号', trigger: 'submit'}
        ],
        price: [
          {required: true, message: '请回填价格', trigger: 'submit'}
        ],
        payType: [
          {required: true, message: '请回填付款方式', trigger: 'submit'}
        ]
      }
    }
  },
  created() {
    // this.route.path = this.$route.fullPath
    const user = JSON.parse(AesDecrypt(window.localStorage.getItem("user")))
    this.userId = user.userId
    this.loadSysProjectData()
    this.param = {
      applyId: this.query.applyId,
      applyServiceId: this.query.applyServiceId,
      applyType: this.query.applyType
    }
    this.getObject()
    this.getAuditShow()
  },
  methods: {
    async loadSysProjectData() {
      let res = await requestProjectAllGet();
      if (res.code === 200) {
        this.allSysProject = res.object;
      } else {
        this.$message.error("获取项目列表失败")
      }
    },
    getAuditShow() {
      requestAuditShow({applyId: this.param.applyId}).then(res => {
        if (res.code === 200) {
          this.allowAudit = res.object === 1
        }
      })
    },
    async getObject() {
      const res = await requestApplyDetail(this.param)
      if (res.code === 200) {
        if (res.object) {
          this.detail = res.object.detail
          this.detail.purchaseType = this.detail.purchaseType.toString()
          this.detail.urgencyLevel = this.detail.urgencyLevel.toString()
          if (this.detail.payType) {
            this.detail.payType = this.detail.payType.toString()
          }
          this.audits = res.object.audits
          this.auditHistory = res.object.auditHistory
          this.user = res.object.user
          this.nodes = res.object.nodes
          if (this.detail.purchaseType === '3') {
            this.detail.projectName = res.object.project.projectName
          }
          // 倒数第二个人回填
          let userId = this.nodes[this.nodes.length - 2].accountId
          // 显示回填信息 回填人审核
          this.show = this.audits.length >= this.nodes.length - 2
          // 编辑回填信息 回填人可编辑
          this.read = userId !== this.userId || !this.show
          // let index = this.nodes.length === 3 ? 1 : 0
          // let len = this.audits.length
          // this.show = this.nodes.length === 3 ? len !== 0 : true
          // let userId = this.nodes[index].accountId
          // const data = await requestAuditShow({applyId: this.param.applyId})
          // this.read = userId !== this.userId || data.object !== 1
        }
      } else {
        this.$message.error(res.msg);
      }
    },
    async audit(isAgree) {
      console.log(this.read)
      if (!this.read && isAgree === 2) {
        const isPass = await this.$refs['detail'].validate()
        if (isPass) {
          const param = {
            purchaseId: this.param.applyServiceId,
            factory: this.detail.factory,
            model: this.detail.model,
            price: this.detail.price,
            payType: this.detail.payType
          }
          const res = await requestPurchaseBack(param)
          if (res.code !== 200){
            this.$message.error("回填失败");
          }
        }
      }
      this.allowAudit = false
      let param = this.param
      param.auditOpinion = isAgree === 2 ? "同意" : "不同意"
      if (this.ruleForm.auditOpinion) {
        param.auditOpinion = this.ruleForm.auditOpinion
      }
      param.isAgree = isAgree
      const res = await requestAudit(param)
      if (res.code === 200) {
        this.getAuditShow()
        await this.getObject()
        this.$message.success(res.msg);
      } else {
        this.$message.error(res.msg);
      }
    }
  }
}
</script>

<style></style>